var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67432 11.3782H29.3782",
    stroke: "#B784FC",
    strokeWidth: 3.00419,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01514 22.0601H10.6855",
    stroke: "#B784FC",
    strokeWidth: 3.00419,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 22.0601H19.3642",
    stroke: "#B784FC",
    strokeWidth: 3.00419,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60258 4.7019H23.4366C28.1899 4.7019 29.3782 5.87688 29.3782 10.5634V21.5254C29.3782 26.2119 28.1899 27.3869 23.4499 27.3869H8.60258C3.86264 27.4002 2.67432 26.2252 2.67432 21.5387V10.5634C2.67432 5.87688 3.86264 4.7019 8.60258 4.7019Z",
    stroke: "#B784FC",
    strokeWidth: 3.00419,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4e48974e5763f80ea0baf05c15799f9e.svg";
export { ForwardRef as ReactComponent };